<template>

  <div id="layout-attente">
    <TopBar/>
    <Notification/>
    <AppHeaderCheckout/>
    <slot/>
    <AppFooterAttente/>
  </div>

</template>

<script>
import AppHeaderCheckout from '@/components/AppHeader-Checkout';
import AppFooterAttente from '@/components/AppFooterAttente';
import Notification from "@/components/Notification";
import TopBar from "@/components/TopBar";

export default {
  components: {
    TopBar,
    AppFooterAttente,
    AppHeaderCheckout,
    Notification,

  }
};
</script>
